import { css } from '@emotion/react';

import colors from '../../configs/colors';

export const bodyStyles = (isPaddingActive, backgroundColor) => css`
  min-height: calc(100vh - 60px);
  padding: ${isPaddingActive ? '40px 0 90px 0' : '0'};
  background-color: ${colors[backgroundColor]};
`;
